Date.prototype.toUTCDate = function () {
    return Date.toUTCDate(this);
};
export {};
